export default ".bx--modal-content {\n  margin-bottom: 2rem;\n  min-height: 60px;\n}\n\n::ng-deep .bx--modal-content--overflow-indicator {\n  display: none;\n}"